// Constants for filter components
export const DRAWER_WIDTH = '33.8rem'
export const FALLBACK_COLOR = '#000000'
export const CLEAR_ALL_THRESHOLD = 2

// Filter keys for telemetry
export const GLOBAL_FILTER_KEY = 'global'
export const COLORS_FILTER_KEY = 'colors-filter'

// Type constants
export const FILTER_TYPES = {
  CARD: 'card',
  CHECKBOX: 'checkbox',
} as const
